const uniquePush = (item, list) =>
  list.findIndex(i => JSON.stringify(i) === JSON.stringify(item)) !== -1 ? list : [...list, item]

export default uniquePush
